import { Card, Grid } from "@material-ui/core";
import {
  Autocomplete,
  Box,
  Button, FormControl, InputLabel, MenuItem, Select,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow, TextField
} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from '@mui/material/Pagination';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilters, useGlobalFilter, usePagination, useTable } from 'react-table';
import axios from "../../../utils/axios";
import { formatNumberSeparatedByCommas } from "../../../utils/strings/Localization";
import './test.css';


const options = [{ tradecode: "No Data Available", name: "" },
// { tradecode: "No Data Available", name: "" },
];

// ---------- Styled Components ----------
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#A7C7E7",
    color: theme.palette.common.black,
    // border:"1px solid gray",
    textAlign:"center",
    height:"10px !important",
    padding:0
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding:0,
    // border:"1px solid gray",
    textAlign:"center"

  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({

  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: '#becbd8ff', // light blue highlight
  },
  '& td': {
    padding: '12px 16px', // custom padding for all cells in the row
  },
}));


function DividendTable({ getDataSync, columns, data, setDataStore, setCurrentPage, currentPage, numberOfPage, showPageSize, setShowPageSize,setNumberOfpage,filters, setFilters, parentLoading}) {
    const { t } = useTranslation();
    
    const [newData, setNewData] = useState([]);
    const [key, setKey] = useState(Date.now());
    const [matches, setMatches] = useState(
        window.matchMedia("(min-width: 768px)").matches
      )

      // const { register, control } = useForm();

    useEffect(()=>
  {axios.get('./issuer/get-info')
  .then((res)=>{
    setNewData(res.data.payload)
  })
  .catch((err) =>{
    alert(err.response.data.message)
  })
},[])

  // console.log(newData)

    const newData2 = newData?newData:options
    var sortedNewData = newData2
    // if (newData2) {
    //   sortedNewData = newData2.slice().sort((a, b) => {
    //     if (a.tradecode < b.tradecode) {
    //       return -1;
    //     }
    //   });
     
    // }


    const defaultColumn = React.useMemo(
        () => ({
            Filter: "",
        }),
        []
    )
    // const {  data:issuer} = useGetIssuerInfoQuery();
    // const issuerData = issuer?.payload
    //console.log(issuerData);
    // const issuerData2 = issuerData;
    //console.log(issuerData2);
    // var sortedIssuerData = issuerData
    // if (issuerData2) {
    //  sortedIssuerData = issuerData2.slice().sort((a, b) => {
    //     if (a.tradecode < b.tradecode) {
    //       return -1;
    //     }
    //   });
     
    // }
    
//console.log(sortedIssuerData);

   // console.log(sortedIssuerData);
        //const sortedIssuerData =  issuerData.sort((a, b) => {return a.autoId - b.autoId })
    
    const userFormatted = JSON.parse(localStorage.getItem('user-name'));
    const userType = userFormatted.userTypes[0]
  
    // const ITEM_HEIGHT = 100;
    // const ITEM_PADDING_TOP = 8;
    
    // const MenuProps = {
    //     PaperProps: {
    //       style: {
    //         //maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    //         // width: 350,
    //         // height:50,
          
           
    //       },
    //     },
    //   };

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        // state,
        // canPreviousPage,
        // canNextPage,
        // pageOptions,
        // pageCount,
        // gotoPage,
        // nextPage,
        // previousPage,
        // setPageSize,
        // preGlobalFilteredRows,
        // setGlobalFilter,
        // state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            defaultColumn,
        },
        useFilters,
        useGlobalFilter,
        usePagination,
    )

    // const nextPageHandler = () =>{        
    //     if(numberOfPage > currentPage){
    //         setCurrentPage(currentPage+1);      
    //     }
    // }

    // const prevPageHandler = () =>{        
    //     if(currentPage > 1){
    //         setCurrentPage(currentPage-1);
    //     }
    // }
    
    // const handleFirstPage = () =>{
    //     if(currentPage !== 1){
    //         setCurrentPage(1)
    //     }
    // }

    // const handleLastPage = () =>{
    //     if(currentPage !== numberOfPage){
    //         setCurrentPage(numberOfPage);
    //     }
    // }

    // const pSize= [5, 10, 20, 30, 40, 50];

    // const [startDate, setStartDate] = useState(null)
    // const [endDate, setEndDate] = useState(null)
    // const [issuerValue, setIssuerValue] = useState("")
   // const [totalCashValue, setTotalCashValue] = useState("")
    //const [totalFcValue, setTotalFcValue] = useState("")
    //const [totalStockValue, setStockValue] = useState("")
    // const [remarksValue, setRemarksValue] = useState("")

    // const [totalCashLower, setTotalCashLower] = useState("")
    // const [totalCashUpper, setTotalCashUpper] = useState("")

    // const [totalFCLower, setTotalFCLower] = useState("")
    // const [totalFCUpper, setTotalFCUpper] = useState("")

    // const [totalStockLower, setTotalStockLower] = useState("")
    // const [totalStockUpper, setTotalStockUpper] = useState("")

    // const dateValue = startDate && endDate ? [startDate, endDate] : null;
    // const totalCashValue = totalCashLower && totalCashUpper ? [totalCashLower, totalCashUpper] : null;
    // const totalFcValue = totalFCLower && totalFCUpper ? [totalFCLower, totalFCUpper] : null;
    // const totalStockValue = totalStockLower && totalStockUpper ? [totalStockLower, totalStockUpper] : null;

    const [grandTotalFromBackend, setGrandTotalFromBackend] = useState({});
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);


    // const [statusValue,setStatusValue]= useState("");
    // const [dividendTypeValue,setDividendTypeValue]= useState("");
    // const paramsData = {
    //     page: currentPage,
    //     take: showPageSize,
    //     issuerid: issuerValue,
    //     status: statusValue,
    //     total_cash: totalCashValue,
    //     total_fc: totalFcValue,
    //     total_stock: totalStockValue,
    //     remarks: remarksValue,
    //     date: dateValue ,
    //     dividendType:dividendTypeValue,
        
    // }
    const paramsData = {
    page: currentPage,
    take: showPageSize,

    issuerid: filters.issuerValue,
    status: filters.statusValue,
    dividendType: filters.dividendTypeValue,

    remarks: filters.remarksValue,

    total_cash:
        filters.totalCashLower && filters.totalCashUpper
            ? [filters.totalCashLower, filters.totalCashUpper]
            : null,

    total_fc:
        filters.totalFCLower && filters.totalFCUpper
            ? [filters.totalFCLower, filters.totalFCUpper]
            : null,

    total_stock:
        filters.totalStockLower && filters.totalStockUpper
            ? [filters.totalStockLower, filters.totalStockUpper]
            : null,

    date:
        filters.startDate && filters.endDate
            ? [filters.startDate, filters.endDate]
            : null,
};

    // const searchResethandler = () =>{
    //     setStartDate(null);
    //     setEndDate(null);
    //     setKey(Date.now());
    //     //setTotalCashValue("");
    //     setTotalCashLower("")
    //     setTotalCashUpper("")
    //     //setTotalFcValue("");
    //     setTotalFCLower("")
    //     setTotalFCUpper("")
    //    // setStockValue("")
    //    setTotalStockLower("")
    //    setTotalStockUpper("")
    //     setRemarksValue("")
    //     setStatusValue("")
    //     setIssuerValue("");
    //     setDividendTypeValue("");
    // }
    const searchResethandler = () => {

    const emptyFilters = {
        issuerValue: "",
        dividendTypeValue: "",
        statusValue: "",
        remarksValue: "",

        startDate: null,
        endDate: null,

        totalCashLower: "",
        totalCashUpper: "",

        totalFCLower: "",
        totalFCUpper: "",

        totalStockLower: "",
        totalStockUpper: "",
    };

    setFilters(emptyFilters);

    sessionStorage.removeItem("inwardDividendFilters");

    setKey(Date.now());
};
    
    
    // const goToPageHandler = (e) =>{
    //     if( e === 0) {   
    //     }
    //     else if(e < 0){
    //     }
    //     else if( e => 1){
    //         setCurrentPage(e);
    //     }else{
    //         setCurrentPage(1); 
    //     }
    // }

    useEffect(()=>{
      setLoading(true);
        axios.post(`inward-dividend/list`,paramsData)
        .then((res) =>{
            // console.log('from table')
            setDataStore(res.data.payload.payload)
            setGrandTotalFromBackend(res.data.payload.grandTotal)
            setTotalCount(res.data.payload?.total || 0)
            if(res.data?.payload.page){
                setNumberOfpage(Math.ceil(res.data.payload?.total/showPageSize))
                // console.log(res.data?.payload?.total)
            }
            
            setLoading(false);
        })
        .catch((err) =>{
          console.log('error from inside')
          setLoading(false);
        })
            
        
        window
        .matchMedia("(min-width: 768px)")
        .addEventListener('change', e => setMatches( e.matches ));

    },[filters.remarksValue,filters.startDate,filters.endDate, filters.issuerValue, filters.totalCashLower, filters.totalCashUpper, filters.totalFCLower, filters.totalFCUpper, filters.totalStockLower, filters.totalStockUpper,filters.statusValue, filters.dividendTypeValue,showPageSize,currentPage])

//console.log(paramsData);

useEffect(()=>{
    setCurrentPage(1)
},[filters.issuerValue,filters.startDate,filters.endDate,filters.totalCashLower,filters.totalCashUpper,filters.totalFCLower,filters.totalFCUpper,filters.totalStockLower,filters.totalStockUpper,filters.statusValue,filters.dividendTypeValue])
// console.log(grandTotalFromBackend)
// console.log(grandTotalFromBackend.total_cash)

const pageSizeOptions = Array.from(
    new Set(
        [10, 20, 30, 50, 100, 500, totalCount, showPageSize]
            .filter((num) => Number(num) > 0 && Number(num) <= Math.max(totalCount, showPageSize))
            .map(Number)
    )
).sort((a, b) => a - b);




    return (
        <div>
          {/* <Paper
    sx={{
        p: 0,
        mb: 0,
        borderRadius: 2,
        backgroundColor:'transparent',
        boxShadow:'none'
    }}
> */}




            <Grid container spacing={2}  justifyContent="center" style={{ margin: "10px 0px 10px 0px" }}>
              
  {userType !== "Issuer" ? (
    <>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <FormControl fullWidth>
          {/* <Autocomplete
            key={key}
            label="Select Issuer"
            blurOnSelect={true}
            // onChange={(event, newValue) => {
            //   setIssuerValue(newValue.id);
            // }}
            onChange={(event,newValue)=>{
                setFilters(prev=>({
                    ...prev,
                    issuerValue: newValue?.id || ""
                }));
            }}
            disableClearable
            options={sortedNewData ? sortedNewData : newData ? newData : options}
            getOptionLabel={(option) =>
              option.name + " (" + option.tradecode + ") "
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Issuer Name"
                size="small"
                placeholder={(option) =>
                  filters.issuerValue === ""
                    ? "choose country"
                    : `${option.name} (${option.tradecode})`
                }
                value={(option) =>console.log(option,filters.issuerValue)
                  // filters.issuerValue === ""
                  //   ? "choose country"
                  //   : `${option.name} (${option.tradecode})`
                }
              />
            )}
          /> */}
          <Autocomplete
    key={key}
    blurOnSelect
    value={
        sortedNewData.find(
            item => item.id === filters.issuerValue
        ) || null
    }
    onChange={(event, newValue) => {
        setFilters(prev => ({
            ...prev,
            issuerValue: newValue?.id || ""
        }));
    }}
    options={sortedNewData || options}
    getOptionLabel={(option) =>
        `${option.name} (${option.tradecode})`
    }
    renderInput={(params) => (
        <TextField
            {...params}
            label="Select Issuer Name"
            size="small"
            placeholder="Choose issuer"
        />
    )}
/>
        </FormControl>
      </Grid>
    </>
  ) : (
    ""
  )}

  <Grid item lg={2} md={6} sm={6} xs={12}>
    <FormControl fullWidth size="small">
      <InputLabel id="issuer-id">Dividend Type</InputLabel>
      <Select
        labelId="issuer-id"
        id="status"
        
        label="Select status"
        // value={dividendTypeValue}
        // onChange={(e) => setDividendTypeValue(e.target.value)}
        value={filters.dividendTypeValue}
        onChange={(e)=>
            setFilters(prev=>({
                ...prev,
                dividendTypeValue: e.target.value
            }))
        }
        
      >
        <MenuItem value="" key="All">
          All
        </MenuItem>
        <MenuItem value="Cash" key="Cash">
          Cash
        </MenuItem>
        <MenuItem value="Stock" key="Stock">
          Stock
        </MenuItem>
        <MenuItem value="FC" key="FC">
          FC
        </MenuItem>
      </Select>
    </FormControl>
  </Grid>

  {/* <Grid item lg={2} md={6} sm={6} xs={12}>
    <FormControl fullWidth size="small">
      <InputLabel id="issuer-id">
        Dividend status
      </InputLabel>
      <Select
        labelId="status"
        id="status"
        value={statusValue}
        label="Select status"
        onChange={(e) => setStatusValue(e.target.value)}
      >
        <MenuItem value="0" key="Initiated">
          Initiated
        </MenuItem>
        <MenuItem value="1" key="Received by Issuer">
          Verified by Issuer
        </MenuItem>
        <MenuItem value="2" key="Approved by Issuer">
          Approved by CMSF
        </MenuItem>
        <MenuItem value="4" key="Received by CMSF">
          Declined by CMSF
        </MenuItem>
      </Select>
    </FormControl>
  </Grid> */}

  <Grid item lg={4} md={12} sm={12} xs={12}>
        <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    {/* <span>
                    Start Date:
                    <input
                        className="form-control"
                        value={startDate || ""}
                        type="date"
                        onChange={(e) => {
                        setStartDate(e.target.value);
                        }}
                        placeholder="search..."
                    />
                    </span> */}

                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-CA'}>
                                    <DatePicker
                                        label="Start date"
                                        disableFuture
                                        value={filters.startDate ? dayjs(filters.startDate) : null}
                                        onChange={(date)=>{
                                                setFilters(prev=>({
                                                    ...prev,
                                                    startDate: date ? date.format("MM/DD/YYYY") : null
                                                }));
                                            }}
                                        slotProps={{
                                                    textField: {
                                                    fullWidth: true,
                                                    size: "small",
                                                    },
                                                }}
                                        />
                                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={6}>
                    {/* <span>
                    End Date:
                    <input
                        className="form-control"
                        value={endDate || ""}
                        type="date"
                        onChange={(e) => {
                        setEndDate(e.target.value);
                        }}
                        placeholder="search..."
                    />
                    </span> */}
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-CA'}>
                                    <DatePicker
                                        label="End date"
                                        disableFuture
                                        value={filters.endDate ? dayjs(filters.endDate) : null}
                                        // onChange={(date) => {
                                        //     setEndDate(date ? date.format("MM/DD/YYYY") : null);
                                        // }}
                                        onChange={(date)=>{
                                            setFilters(prev=>({
                                                ...prev,
                                                endDate: date ? date.format("MM/DD/YYYY") : null
                                            }));
                                        }}
                                        slotProps={{
                                                    textField: {
                                                    fullWidth: true,
                                                    size: "small",
                                                    },
                                                }}
                                        />
                                    </LocalizationProvider>
                    </Grid>
            </Grid>
    </Grid>

    {/* <Grid item lg={2} md={2} sm={2} xs={12}>
          <span>
            Total Cash:
            <input
                className="form-control"
                type='number'
                value={totalCashLower || ""}
                onChange={e => {
                    setTotalCashLower(e.target.value);
                    //setTotalCashValue(e.target.value);
                }}
                placeholder={` from...`}
            />
        </span>
          <span>
            <input style={{marginTop: '5px'}}
                className="form-control"
                type='number'
                value={totalCashUpper || ""}
                onChange={e => {
                    setTotalCashUpper(e.target.value);
                    //setTotalCashValue(e.target.value);
                }}
                placeholder={` to...`}
            />
        </span>
          </Grid> */}

          {/* <Grid item lg={1} md={1} sm={1} xs={12}>
          <span>
            Total FC:{' '}
            <input
                className="form-control"
                type='number'
                value={totalFCLower || ""}
                onChange={e => {
                    setTotalFCLower(e.target.value)
                    //setTotalFcValue(e.target.value);
                }}
                placeholder={`from...`}
            />
        </span>
        <span>
            {' '}
            <input style={{marginTop: '5px'}}
                className="form-control"
                type='number'
                value={totalFCUpper || ""}
                onChange={e => {
                    setTotalFCUpper(e.target.value)
                    //setTotalFcValue(e.target.value);
                }}
                placeholder={`to...`}
            />
        </span>
          </Grid> */}
          {/* <Grid item lg={2} md={2} sm={2} xs={12}>
            <span>
                Total Stock:{' '}
                <input
                    className="form-control"
                    type='number'
                    value={totalStockLower || ""}
                    onChange={e => {
                        setTotalStockLower(e.target.value)
                        //setStockValue(e.target.value);
                    }}
                    placeholder={` from...`}
                />
            </span>
            <span>
              {' '}
            <input style={{marginTop: '5px'}}
                className="form-control"
                type='number'
                value={totalStockUpper || ""}
                onChange={e => {
                    setTotalStockUpper(e.target.value)
                   // setStockValue(e.target.value);
                }}
                placeholder={` to...`}
            />
        </span>
          </Grid> */}
          {/* <Grid item lg={1} md={1} sm={1} xs={12}>
           <span>
            Remarks:{' '}
            <input
                className="form-control"
                value={remarksValue || ""}
                onChange={e => {
                    setRemarksValue(e.target.value);
                }}
                placeholder={` search...`}
            />
        </span> 
        </Grid> */}

                <Grid
                    item
                    lg={1}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    }}
                >
                    <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    style={{
                        backgroundColor: "#DC143C",
                        color: "#fff",
                        width: "100%",
                    }}
                    onClick={searchResethandler}
                    >
                    {t("common.reset")}
                    </Button>
                </Grid>
                </Grid>
                {/* </Paper> */}
          {/* <Grid container style={{ overflowX: 'auto'}}> */}
          <Card
    sx={{
        borderRadius: 3,
        overflow: "hidden",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        
    }}
>
    {/* <div style={{ overflowX: "auto", maxHeight: "70vh" }}>
      <table className="modern-table" {...getTableProps()} style={{width:"100%"}}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>
                  {column.render('Header')}
                  <div>{column.canFilter ? column.render('Filter') : null}</div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
  {rows.map((row, i) => {
    prepareRow(row);
    return (
      <tr {...row.getRowProps()}>
        {row.cells.map(cell => {
          return (
            <td 
            style={{wordWrap: 'break-word',
            whiteSpace: 'none',
            textAlign: "center",
            verticalAlign: "middle",
            maxWidth: matches?'13rem':'25rem'}} 
                {...cell.getCellProps()} data-label={cell.column.render('Header')}>
              {cell.render('Cell')}
            </td>
          );
        })}
      </tr>
    );
  })}
</tbody>
</table>

</div> */}
<Paper
  sx={{
    mx: 1,
    boxShadow: 2,
    border: "1px solid gray",
    position: "relative",
    overflow: "hidden",
  }}
>


{(parentLoading || loading) && (
        <Box
            sx={{
                position: "absolute",
                inset: 0,
                background: "rgba(255,255,255,0.75)",
                backdropFilter: "blur(2px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
            }}
        >
            <CircularProgress />
        </Box>
    )}
  <TableContainer
    sx={{
      maxHeight: "70vh",
      overflow: "auto",
    }}
  >
    <Table stickyHeader {...getTableProps()}>
      <TableHead>
        {headerGroups.map((headerGroup) => (
          <StyledTableRow {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <StyledTableCell
                {...column.getHeaderProps()}
                align="center"
                sx={{
                  fontWeight: "bold",
                  backgroundColor: "#dce6f2",
                  minWidth: column.minWidth,
                  // border: "10px solid red",
                  margin: "5px 5px",
                }}
              >
                {column.render("Header")}

                {column.canFilter && (
                  <div>
                    {column.render("Filter")}
                  </div>
                )}
              </StyledTableCell>
            ))}
          </StyledTableRow>
        ))}
      </TableHead>

      <TableBody {...getTableBodyProps()}>
        {rows.length ? (
          rows.map((row) => {
            prepareRow(row);

            return (
              <StyledTableRow
                hover
                {...row.getRowProps()}
              >
                {row.cells.map((cell) => (
                  <StyledTableCell
                    {...cell.getCellProps()}
                    align="center"
                    sx={{
                      verticalAlign: "middle",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                      maxWidth: matches ? "13rem" : "25rem",
                    }}
                  >
                    {cell.render("Cell")}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            );
          })
        ) : (
          <StyledTableRow>
            <StyledTableCell
              colSpan={columns.length}
              align="center"
            >
              No Data Available
            </StyledTableCell>
          </StyledTableRow>
        )}
      </TableBody>

    </Table>
  </TableContainer>
  <Box display="flex" justifyContent="space-between" alignItems="center" sx={{paddingRight:"2px"}}>
        <Pagination
          count={numberOfPage}
          page={currentPage}
          onChange={(_, page) => setCurrentPage(page)}
          color="primary"
          size="small"
          style={{padding:"2px 0px",margin:0,fontSize:"15px"}}
        />

        <FormControl variant="outlined" size="small" p={0} m={0}>
          <Select
            value={showPageSize}
            onChange={(e) => {
              setCurrentPage(1);
              setShowPageSize(Number(e.target.value));
            }}
            style={{padding:0,margin:0,height:"15px",fontSize:"15px"}}
          >
            {pageSizeOptions.map((num) => (
              <MenuItem key={num} value={num}>
                {num === totalCount ? `All (${num})` : `${num} / page`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
</Paper>


</Card>
                      {/* <Card 
                    style={{ 
                          display: "flex",
                          justifyContent: "flex-end", // Push content to the right
                          //  justifyContent: "center", // Push content to the right
                          alignItems: "center",
                          padding: "8px 335px", // Add spacing inside the card
                          marginBottom: "8px", // Space between rows
                          width: "100%", // Full-width like a table row
                          backgroundColor: "#9FE2BF	", // Optional: Light background color
                          border: "1px solid #ddd", // Border to mimic a table row
                          borderRadius: "4px", // Slight rounding
                          }}> 
                      <div
                      style={{
                          fontSize: "16px", // Increase the font size
                          fontWeight: "bold", // Optional: Make the text bold
                          marginRight:'220px'
                              }}
                      >
                          Grand Total Cash : {grandTotalFromBackend.total_cash} BDT
                      </div>
                      </Card>     
                      <Card style={{ 
                              display: "flex",
                              justifyContent: "flex-end", 
                              alignItems: "center",
                              padding: "8px 340px", 
                              marginBottom: "8px", 
                              width: "100%", 
                              backgroundColor: "#9FE2BF	", 
                              border: "1px solid #ddd", 
                              borderRadius: "4px", 
                          }}>  <div
                          style={{
                              fontSize: "16px", // Increase the font size
                              fontWeight: "bold", // Optional: Make the text bold
                              marginRight:'220px'
                          }}
                      >
                          Grand Total Stock: {grandTotalFromBackend.total_stock} Nos
                          
                      </div>
                      </Card>   */}
                      <Paper
                          sx={{
                              mb: 2,
                              // p: 2,
                              display: "flex",
                              justifyContent: "space-around",
                              bgcolor: "#a7c7e7",
                              // bgcolor:"#9FE2BF"
                          }}
                      >
                          {/* <Typography fontWeight={400}
                          sx={{
                            // border: "1px solid #1976d2",
                            p:1,
                            borderRadius:2,
                            // color:'#1976d2',
                            fontSize:'14px',
                            fontWeight:'bold',
                          }}
                          >
                              Grand Total Cash: {formatNumberSeparatedByCommas(grandTotalFromBackend.total_cash)} BDT 
                          </Typography>

                          <Typography fontWeight={400}
                          sx={{
                           // border: "1px solid #1976d2",
                            p:1,
                            borderRadius:2,
                            // color:'#1976d2',
                            fontSize:'14px',
                            fontWeight:'bold',
                          }}
                          >
                              Grand Total Stock:  {formatNumberSeparatedByCommas(grandTotalFromBackend.total_stock)} Nos
                          </Typography> */}
                          {loading ? (
    <>
      <Skeleton variant="rounded" width={220} height={35} />
      <Skeleton variant="rounded" width={220} height={35} />
    </>
  ) : (
    <>
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: "bold",
        }}
      >
        Grand Total Cash:{" "}
        {formatNumberSeparatedByCommas(grandTotalFromBackend.total_cash)} BDT
      </Typography>

      <Typography
        sx={{
          fontSize: 14,
          fontWeight: "bold",
        }}
      >
        Grand Total Stock:{" "}
        {formatNumberSeparatedByCommas(grandTotalFromBackend.total_stock)} Nos
      </Typography>
    </>
  )}
                      </Paper>
                      
            {/* </Grid> */}
            {/* <ul className="pagination">
                <li className="page-item" onClick={handleFirstPage} disabled={!canPreviousPage}>
                    <span style={{cursor: "grab"}} className="page-link">First</span>
                </li>
                <li className="page-item" onClick={prevPageHandler}
                 disabled={!canPreviousPage}
                 >
                    <span style={{cursor: "grab"}} className="page-link">{'<'}</span>
                </li>
                <li className="page-item" onClick={nextPageHandler}
                 disabled={!canNextPage}
                 >
                    <span style={{cursor: "grab"}} className="page-link">{'>'}</span>
                </li>
                <li className="page-item" onClick={handleLastPage} disabled={!canNextPage}>
                    <span style={{cursor: "grab"}} className="page-link">Last</span>
                </li>
                <li>
                    <a className="page-link">
                        Page{' '}
                        <strong>
                            {currentPage} of {numberOfPage}
                        </strong>{' '}
                    </a>
                </li>
                <li>
                    <a className="page-link">
                        <input
                            className="form-control"
                            type="number"
                            defaultValue={pageIndex + 1}
                            onChange={e => {
                                goToPageHandler(e.target.value)
                            }}
                            style={{ width: '100px', height: '20px' }}
                        />
                    </a>
                </li>{' '}
                <select
                    className="form-control"
                    value={showPageSize}
                    onChange={e => {
                        setShowPageSize(Number(e.target.value))
                    }}
                    style={{ width: '120px', height: '38px' }}
                >
                    {pSize.map(pageSize => (
                        <option key={pageSize} value={pageSize} >
                            Show {pageSize}
                        </option>
                    ))}
                </select>
            </ul> */}
            {/* <Pagination
                count={numberOfPage}
                page={currentPage}
                onChange={(e, page) => setCurrentPage(page)}
                color="primary"
                shape="rounded"
            /> */}
  
        </div>
    )
}

export default DividendTable;
